import React from "react";
import * as ROUTES from "../constants/routes";
import logo from '../logo.png' 
import { Header, Profiles } from "../components";


export function SelectProfileContainer({ user, setProfile }) {
   return (
      <>
         <Header bg={false}>
            <Header.Frame>
               <Header.Logo to={ROUTES.HOME} src={logo} alt="Netflix"/ >
            </Header.Frame>
         </Header>

         <Profiles>
            <Profiles.Title>Who's watching?</Profiles.Title>
            <Profiles.List>
               <Profiles.User>
                  <Profiles.Picture src={user.photoUrl} />
                  <Profiles.Name>{user.displayName}</Profiles.Name>
               </Profiles.User>
               </Profiles.List>
         </Profiles>
      </>
   )

}